import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";

import HomeView from "../views/HomeView/HomeView";
import { Typography } from "@mui/material";
import NewTicketView from "../views/NewTicketView/NewTicketView";
import TicketView from "../views/TicketView/TicketView";
import TicketsView from "../views/TicketsView/TicketsView";
import UserSettingsView from "../views/UserSettingsView/UserSettingsView";
import UserPasswordResetView from "../views/UserPasswordResetView/UserPasswordResetView";
import TicketSuccessView from "../views/TicketSuccessView/TicketSuccessView";
import NotFoundView from "../views/NotFoundView/NotFoundView";
import IntakeView from "../views/IntakeView/IntakeView";
import UserDocumentsView from "../views/UserDocumentsView/UserDocumentsView";
import UserMessagesView from "../views/UserMessagesView/UserMessagesView";

const AuthRouter = createBrowserRouter(
  [
    {
      path: "/",
      element: <HomeView />,
    },
    {
      path: "/home",
      element: <HomeView />,
    },
    {
      path: "/new-ticket",
      element: <NewTicketView />,
    },
    {
      path: "/tickets",
      element: <TicketsView />,
    },
    {
      path: "/ticket",
      element: <TicketView />,
    },
    {
      path: "/ticket-success",
      element: <TicketSuccessView />,
    },
    {
      path: "/settings",
      element: <UserSettingsView />,
    },
    {
      path: "/reset-password",
      element: <UserPasswordResetView />,
    },
    {
      // Same as in DefaultRouter: a signed-in visitor must see the same intake page as anyone else,
      // and staff need to be able to open it to check what a client is shown.
      path: "/non-cdl/:tier",
      element: <IntakeView />,
    },
    {
      path: "/cdl/:tier",
      element: <IntakeView />,
    },
    {
      path: "documents",
      element: <UserDocumentsView />,
    },
    {
      path: "messages",
      element: <UserMessagesView />,
    },
    {
      path: "*",
      element: <NotFoundView />,
    },
  ],
  {}
);
export default AuthRouter;